<template>
  <div class="home">
    <top-box></top-box>
    <top-menu
      :selectedKeys="selectedKeys"
      :menuList="menuList"
      @set-menu="onSetMenu"
    ></top-menu>
    <div class="content-area">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import TopBox from "@/components/TopBox.vue";
import TopMenu from "@/components/TopMenu.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: { TopBox, TopMenu },
  computed: {
    ...mapGetters({
      userInfo: "userInfo",
      hasLogin: "hasLogin",
      isSalesHead: "isSalesHead",
      isAdmin: "isAdmin",
      isChinaManager: "isChinaManager",
      isLogist: "isLogist",
      isProduct: "isProduct",
      isProductHead: "isProductHead",
      isAccountant: "isAccountant",
      isCustoms: "isCustoms",
      isSuperAdmin: "isSuperAdmin",
      canViewOrderTasks: "canViewOrderTasks",
      canViewSalesPlans: "canViewSalesPlans",
      getRoleNames: "getRoleNames",
      getDepartmentName: "getDepartmentName",
    }),
    selectedMenuItem() {
      const currentPath = this.$route.path;
      let selected;
      this.menuList.forEach((menuItem) => {
        if (selected) return;
        if (menuItem.children?.length) {
          menuItem.children.forEach((child) => {
            if (currentPath.startsWith(child.path)) {
              selected = child;
            }
          });
        } else {
          if (currentPath.startsWith(menuItem.path)) {
            selected = menuItem;
          }
        }
      });
      return selected;
    },
    selectedKeys() {
      if (!this.selectedMenuItem) return [];
      return [this.selectedMenuItem.routerName];
    },
    menuList() {
      console.log("store: allInfo", {
        userInfo: this.userInfo,
        isAdmin: this.isAdmin,
        isLogist: this.isLogist,
        isSalesHead: this.isSalesHead,
        isChinaManager: this.isChinaManager,
        isProduct: this.isProduct,
        // Диагностика доступа к задачам по заказам: видно, по чему именно
        // не опознаётся таможня — по группам или по отделу.
        isCustoms: this.isCustoms,
        canViewOrderTasks: this.canViewOrderTasks,
        roleNames: this.getRoleNames,
        departmentName: this.getDepartmentName,
      });
      // prettier-ignore
      const all = [
        // ─── visible to all (except isChinaManager — handled below) ───────────
        { show: !this.isChinaManager,                          nameTag: "l_Requests",           routerName: "RequestsView",          path: "/requests",          icon: "QuestionCircleOutlined",
          children: [
            { label: "l_Requests",         routerName: "RequestsRequest", path: "/requests",           key: "RequestsRequest" },
            { label: "l_Archive_requests", routerName: "ArchiveRequests", path: "/requests/archive",   key: "ArchiveRequests" },
            { label: "l_Info_requests",    routerName: "InfoRequests",    path: "/requests/info-requests", key: "InfoRequests" },
          ],
        },
        { show: true,                                          nameTag: "l_Orders",             routerName: "OrdersView",            path: "/orders/order",      icon: "UnorderedListOutlined"  },
        { show: this.canViewOrderTasks,                        nameTag: "l_Order_tasks",        routerName: "OrderTasksView",        path: "/order-tasks",       icon: "CheckSquareOutlined"    },
        { show: !this.isChinaManager,                          nameTag: "l_Trips",              routerName: "Trips",                 path: "/order-trip",        icon: "CarOutlined"            },
        { show: !this.isChinaManager,                          nameTag: "l_Clients",            routerName: "ClientsView",           path: "/clients",           icon: "UserOutlined"           },

        // ─── role-specific items ───────────────────────────────────────────────
        { show: this.isAdmin || this.isProduct || this.isLogist,    nameTag: "l_Carriers",           routerName: "CarriersView",          path: "/carrier",           icon: "ShopOutlined"           },
        { show: this.isAdmin || this.isLogist || this.isProduct, nameTag: "l_Additional_expenses",routerName: "AdditionalExpensesView",path: "/additional-expenses",icon: "DollarOutlined"        },
        { show: this.canViewSalesPlans,                         nameTag: "l_Sales_plans",        routerName: "SalesPlansView",        path: "/sales-plans",       icon: "FundOutlined"           },

        // ─── Settings (children filtered per role) ─────────────────────────────
        { show: this.isLogist || this.isSalesHead || this.isAdmin || this.isAccountant || this.isProductHead, nameTag: "l_Settings", routerName: "RoleList", icon: "SettingOutlined",
          children: [
            { show: this.isAdmin,                              label: "l_Organization",  routerName: "Organization",  path: "/role/organization",        key: "Organization"  },
            { show: this.isLogist || this.isAdmin,             label: "l_Client_to_user",routerName: "ClientToUser",  path: "/client/user",              key: "ClientToUser"  },
            { show: this.isLogist || this.isAdmin,             label: "l_Carrier_to_user",routerName: "CarrierToUser", path: "/client/carrier-user",     key: "CarrierToUser" },
            { show: this.isAdmin || this.isSalesHead || this.isLogist, label: "l_Templates", routerName: this.isAdmin ? "TemplateList" : "ManagerAssignmentTemplates", path: "/role/document/templates", key: this.isAdmin ? "TemplateList" : "ManagerAssignmentTemplates" },
            { show: this.isSalesHead || this.isAdmin || this.isProductHead, label: "l_Classifier", routerName: this.isSalesHead || this.isAdmin ? "Classifier" : "BankView", path: "/role/classifiers", key: this.isSalesHead || this.isAdmin ? "Classifier" : "BankView" },
            { show: this.isAdmin || this.isAccountant || this.isLogist,         label: "l_Exchange_rates",routerName: "ExchangeRates", path: "/role/exchange-rate",  key: "ExchangeRates" },
            { show: this.isAdmin,                              label: "l_Log",           routerName: "Logs",          path: "/role/log",                 key: "Logs"          },
            { show: this.isAdmin,                              label: "l_System_break",  routerName: "SystemBreak",   path: "/role/system-break",        key: "SystemBreak"   },
          ].filter((c) => c.show),
        },
      ];

      return all.filter((item) => item.show);
    },
  },
  methods: {
    ...mapMutations({ setPermissionList: "setPermissionList" }),
    onSetMenu(key) {
      this.$router.push({ name: key });
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;

  .content-area {
    padding: 0 15px;
    box-sizing: border-box;
  }
}
</style>
